var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseNocircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2661 4.66021L11.4604 3.85449L8.26611 7.04878L5.07183 3.85449L4.26611 4.66021L7.4604 7.85449L4.26611 11.0488L5.07183 11.8545L8.26611 8.66021L11.4604 11.8545L12.2661 11.0488L9.07183 7.85449L12.2661 4.66021Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNocircle);
export default __webpack_public_path__ + "static/media/close_nocircle.9174f0365c9cced1ce692e6cfab687ec.svg";
export { ForwardRef as ReactComponent };